/**
 * i18n number and datetime format configurations.
 */

import type { NumberOptions, DateTimeOptions } from 'vue-i18n'

const makeDatetimeFormat = (hour12 = false): Record<string, DateTimeOptions> => ({
  short: { year: 'numeric', month: '2-digit', day: '2-digit' },
  long: { year: 'numeric', month: 'long', day: 'numeric' },
  // Compact labels for chart axes — localized per the user's locale.
  monthShort: { year: 'numeric', month: 'short' },
  dayShort: { day: '2-digit', month: 'short' },
  datetime: {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12
  }
})

const makeNumberFormat = (currency: string): Record<string, NumberOptions> => ({
  currency: { style: 'currency', currency, notation: 'standard', currencyDisplay: 'symbol' },
  decimal: { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 },
  integer: { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0 },
  percent: { style: 'percent', useGrouping: false }
})

export const numberFormats = {
  'pt-BR': makeNumberFormat('BRL'),
  'en-US': makeNumberFormat('USD'),
  'en-GB': makeNumberFormat('GBP'),
  'es-ES': makeNumberFormat('EUR'),
  'es-GT': makeNumberFormat('GTQ'),
  'es-CL': makeNumberFormat('CLP'),
  'es-EC': makeNumberFormat('USD'),
  'fr-FR': makeNumberFormat('EUR'),
  'pt-PT': makeNumberFormat('EUR'),
  'pt-AO': makeNumberFormat('AOA')
}

export const datetimeFormats = {
  'pt-BR': makeDatetimeFormat(false),
  'en-US': makeDatetimeFormat(true),
  'en-GB': makeDatetimeFormat(false),
  'es-ES': makeDatetimeFormat(false),
  'es-GT': makeDatetimeFormat(false),
  'es-CL': makeDatetimeFormat(false),
  'es-EC': makeDatetimeFormat(false),
  'fr-FR': makeDatetimeFormat(false),
  'pt-PT': makeDatetimeFormat(false),
  'pt-AO': makeDatetimeFormat(false)
}
